import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { GetMonthlyNewsletterSubscribersRequest } from './get-monthly-newsletter-subscribers.request';
import { GetMonthlyNewsletterSubscribersResponse } from './get-monthly-newsletter-subscribers.response';

@Injectable({ providedIn: 'root' })
export class GetMonthlyNewsletterSubscribersUseCase extends UseCase<GetMonthlyNewsletterSubscribersRequest, Observable<GetMonthlyNewsletterSubscribersResponse>> {
    private _apiRequestService = inject(ApiRequestService);
    private _emailBaseUrl = inject<string>('EMAIL_BACKEND_URL' as never);
    private _getNewsletterSubscriberSnapshotsUrl = '/admin/getNewsletterSubscriberSnapshots';

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(
        request: GetMonthlyNewsletterSubscribersRequest | void
    ): Observable<GetMonthlyNewsletterSubscribersResponse> | void {
        return this._apiRequestService.sendRequest<GetMonthlyNewsletterSubscribersRequest, GetMonthlyNewsletterSubscribersResponse>(
            this._emailBaseUrl,
            request as GetMonthlyNewsletterSubscribersRequest,
            true,
            this._getNewsletterSubscriberSnapshotsUrl
        );
    }
}
